<script setup>
import { computed, watch } from 'vue'
import { useLayoutWidth } from '@/core/composables/use-layout-width.composable'
import { useAuthStore } from '@/modules/auth/stores/auth.store'
import BradleyFloatingWidget from '@/modules/new-bradley/components/bradley-floating-widget.vue'
import BradleySidePanel from '@/modules/new-bradley/components/bradley-side-panel.vue'
import DssBreadcrumb from '@/shared/components/dss-breadcrumb/dss-breadcrumb.vue'
import { useBreadcrumbStore } from '@/shared/stores/breadcrumb.store.js'
import { useLanguageStore } from '../stores/language.store.js'

defineOptions({
  name: 'ShellLayout',
})

const breadcrumbStore = useBreadcrumbStore()
const displayBreadcrumb = computed(() => breadcrumbStore.displayBreadcrumb)
const { isFullWidth } = useLayoutWidth()

const authStore = useAuthStore()
const languageStore = useLanguageStore()

watch(
  () => authStore.tenantData,
  async (tenantData) => {
    if (tenantData) {
      await languageStore.fetchAvailableLocales()
      languageStore.initialize()
    }
  },
  { immediate: true },
)

watch(
  () => languageStore.getActiveLocales.map(l => l.key).join(','),
  () => languageStore.initialize(),
)
</script>

<template>
  <div
    :key="languageStore.languageCounter"
    class="flex flex-col shell-layout-holder"
    :class="isFullWidth ? '' : 'shell-layout-container'"
  >
    <dss-header />
    <bradley-side-panel />
    <bradley-floating-widget />

    <div class="h-full bg-dss-secondary-500">
      <div class="flex bg-white dark:bg-dss-surface-0 rounded-tl-[20px] p-10 gap-x-16">
        <dss-menu />

        <main class="flex-1 flex flex-col overflow-hidden">
          <dss-breadcrumb v-if="displayBreadcrumb" />

          <div class="flex-1 overflow-x-auto w-full">
            <router-view />
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<style scoped>
.shell-layout-holder {
  min-width: 1264px;
}

.shell-layout-container {
  max-width: min(1440px, calc(100% - 64px));
  margin-left: auto;
  margin-right: auto;
}
</style>
